import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ActiveAccount {
	account_id: string;
	type: string;
	active: boolean;
}

export const useActiveAccounts = () => {
	const [hasActiveAccounts, setHasActiveAccounts] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<string | null>(null);

	const checkActiveAccounts = async () => {
		try {
			setLoading(true);
			setError(null);

			// Get the current user
			const { data: { user }, error: userError } = await supabase.auth.getUser();
			if (userError || !user) {
				setError('User not authenticated');
				setHasActiveAccounts(false);
				return;
			}

			// Query the database directly for active accounts
			const { data: accounts, error: dbError } = await supabase
				.from('unipile_account')
				.select('id, status')
				.eq('user_id', user.id);

			if (dbError) {
				console.error('Error fetching accounts from database:', dbError);
				setError('Failed to check active accounts');
				setHasActiveAccounts(false);
				return;
			}

			setHasActiveAccounts(Array.isArray(accounts) && accounts.length > 0);
            
		} catch (err) {
			console.error('Error checking active accounts:', err);
			setError('Failed to check active accounts');
			setHasActiveAccounts(false);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		checkActiveAccounts();
	}, []);

	return {
		hasActiveAccounts,
		loading,
		error,
		refetch: checkActiveAccounts,
	};
};
